import type { TellentMember, TellentOrgAbilities } from '@core/tellent-types';

export type AbilitiesCheckPair = { admin: TellentMember; member: TellentMember };

export enum AbilityEditLevel {
  None = 1, // No permissions
  User, // Administrative access
  Admin, // Full access
}

export type CheckFn = (data: AbilitiesCheckPair) => boolean;

type AbilityConfig = {
  id: TellentOrgAbilities;
  getControlState: (data: AbilitiesCheckPair) => { value: boolean; disabled: boolean };
  hidden: boolean;
};

export type AbilityGroupConfig = {
  abilities: Array<TellentOrgAbilities | AbilityConfig>;
  canView: CheckFn;
  canEdit: CheckFn;
  match: CheckFn;
};

export type AbilityGroupViewModel = {
  id: AbilityEditLevel;
  abilities: AbilityConfig[];
  canView: boolean;
  match: boolean;
  canEdit: boolean;
};
